import React, { useMemo } from "react";

import ChooseSubscriptionImage from "@common/assets/images/FTUX/billing-choose-subscription.png";
import PageStateView from "@common/components/PageStateView/components/PageStateView";
import { useNoSubscriptionConsumer } from "@common/components/PageStateView/consumers/useNoSubscriptionConsumer";
import { Spinner } from "@common/components/Spinner/Spinner";
import { getBillableApps } from "@common/util/appsUtil";
import { didWSReachLimit } from "@main/context/Subscription/SubscriptionContext";
import { generatePath, useParams } from "react-router-dom";

import { useAppContext } from "../../context/App/App.context";
import { useAppSelectionContext } from "../../context/App/AppSelectionContext";
import { RoutePaths } from "../../router/config/routePaths";

export default function NoSubscriptionPage() {
  const { selectedWorkspace } = useAppSelectionContext();
  const { workspaceSlug } = useParams();
  const { apps } = useAppContext();
  const { teamData, loading } = useNoSubscriptionConsumer();

  const buttonUrl = generatePath(RoutePaths.ADMINISTRATION_BILLING, { workspaceSlug: workspaceSlug ?? null });

  const activeApps = useMemo(() => getBillableApps(apps), [apps]);

  if (!selectedWorkspace || loading || !teamData) {
    return <Spinner />;
  }

  if (didWSReachLimit(selectedWorkspace, activeApps, teamData.members)) {
    return (
      <PageStateView
        title="Which plan & add-on to choose"
        subtitle="Your usage of Shake exceeds your current workspace subscription. You can always check your workspace numbers and pick the appropriate subscription."
        imageSrc={ChooseSubscriptionImage}
        button={{ url: buttonUrl, title: "See subscription options" }}
      />
    );
  }

  return <div />;
}
